export default __webpack_public_path__ + "static/media/portada_NickAlbert.eea558dc.jpg";